import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';

const socialLinks = [
  {
    label: 'Toma la Encuesta sobre nuestro Evento',
    url: 'https://encuesta.prosperityleaders.net/',
    icon: FiIcons.FiClipboard,
    featured: true
  },
  {
    label: 'Instagram',
    url: 'https://instagram.com/mujeresyriquezas',
    icon: FiIcons.FiInstagram
  },
  {
    label: 'Facebook',
    url: 'https://facebook.com/mujeresyriquezas',
    icon: FiIcons.FiFacebook
  },
  {
    label: 'TikTok',
    url: 'https://tiktok.com/@mujeresyriquezas',
    icon: FiIcons.FiMusic
  },
  {
    label: 'LinkedIn',
    url: 'https://linkedin.com/in/prosperityleaders',
    icon: FiIcons.FiLinkedin
  },
  {
    label: 'Sitio web',
    url: 'https://prosperityleaders.net',
    icon: FiIcons.FiGlobe
  }
];

const Social = () => {
  return (
    <div className="min-h-screen font-sans text-slate-900 bg-white">
      <Header />
      <main className="pt-28 pb-20">
        <section className="py-16 bg-gradient-to-b from-pink-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto text-center mb-10">
              <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Conecta con Mujeres y Riquezas</h1>
              <p className="text-gray-600 text-lg">
                Elige una opción para seguirnos en redes o visitar nuestro sitio principal.
              </p>
            </div>

            <div className="max-w-2xl mx-auto space-y-4">
              {socialLinks.map((link) => (
                <a
                  key={link.url}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-full rounded-2xl transition-all duration-300 flex items-center justify-center gap-3 text-center ${
                    link.featured
                      ? 'px-6 py-6 text-lg md:text-xl font-extrabold bg-gradient-to-r from-fuchsia-600 via-pink-600 to-rose-500 text-white shadow-2xl shadow-pink-300/60 hover:scale-[1.02] hover:shadow-pink-400/70 border-2 border-white'
                      : 'px-5 py-4 text-base font-semibold bg-pink-600 text-white hover:bg-pink-700 shadow-lg'
                  }`}
                >
                  <SafeIcon icon={link.icon} className={link.featured ? 'text-2xl' : 'text-xl'} />
                  <span>{link.label}</span>
                  {link.featured && <SafeIcon icon={FiIcons.FiArrowRight} className="text-2xl" />}
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Social;
